var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    viewBox: "0 -75 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m482 205.667969v25.269531h-33.730469v-18.445312l-38.097656-47.222657h-27.496094v-51.871093h-87.921875v-25.398438h42.578125v-88h-187.332031v88h42.578125v25.398438h-59.835937v42.378906h-74.929688v61.539062h-27.8125v-34.125h-30v98.25h30v-34.125h27.8125v72.324219h86.214844l37.65625 41.570313h266.585937v-24.3125h33.730469v24.101562h30v-155.332031zm-129.324219-62.269531v51.871093h43.152344l22.441406 27.816407v108.125h-195.691406v-187.8125zm-172.675781-85.398438v-28h127.332031v28zm42.578125 30h42.175781v25.398438h-42.175781zm-134.765625 97.777344h44.929688v103.863281h-44.929688zm74.929688 109.835937v-152.214843h29.835937v185.15625zm285.527343 11.285157v-45.960938h33.730469v45.960938zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/motor.cc618e3070f9aff36d9ccaf44e62b75a.svg";
export { ForwardRef as ReactComponent };